import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import API_URL from '../config';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';

  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');
  const [resendEmail, setResendEmail] = useState('');
  const [resendSent, setResendSent] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Missing verification token. Please use the link from your email.');
      return;
    }
    const verify = async () => {
      try {
        const res = await fetch(`${API_URL}/api/auth/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        const data = await res.json();
        if (!res.ok) {
          setStatus('error');
          setMessage(data.error || 'Verification failed');
        } else {
          setStatus('success');
          setMessage(data.message || 'Email verified successfully.');
        }
      } catch {
        setStatus('error');
        setMessage('Network error. Please try again.');
      }
    };
    verify();
  }, [token]);

  const handleResend = async (e) => {
    e.preventDefault();
    setResendLoading(true);
    try {
      await fetch(`${API_URL}/api/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: resendEmail }),
      });
      setResendSent(true);
    } catch {}
    setResendLoading(false);
  };

  return (
    <div className="container" style={{ maxWidth: '420px', marginTop: '50px' }}>
      <div className="card">
        <h1 style={{ marginBottom: '30px', textAlign: 'center' }}>Agent Oversight</h1>
        <h2 style={{ marginBottom: '20px', fontSize: '20px' }}>Email Verification</h2>

        {status === 'verifying' && (
          <p style={{ color: 'var(--text-secondary)', fontSize: 14 }}>Verifying your email...</p>
        )}

        {status === 'success' && (
          <>
            <div className="alert success">{message}</div>
            <p style={{ marginTop: 16, textAlign: 'center', fontSize: '14px' }}>
              <Link to="/login">Proceed to Login</Link>
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="alert error">{message}</div>

            <div style={{ marginTop: 24 }}>
              <p style={{ fontSize: 14, color: 'var(--text-secondary)', marginBottom: 12 }}>
                Need a new verification link?
              </p>
              {resendSent ? (
                <div className="alert success" style={{ fontSize: 13 }}>
                  A new link has been sent if that email is unverified.
                </div>
              ) : (
                <form onSubmit={handleResend} style={{ display: 'flex', gap: 8 }}>
                  <input
                    type="email"
                    value={resendEmail}
                    onChange={(e) => setResendEmail(e.target.value)}
                    placeholder="your@email.com"
                    required
                    disabled={resendLoading}
                    style={{ flex: 1 }}
                  />
                  <button type="submit" disabled={resendLoading} className="btn-primary">
                    {resendLoading ? '...' : 'Resend'}
                  </button>
                </form>
              )}
            </div>

            <p style={{ marginTop: 20, textAlign: 'center', fontSize: '14px' }}>
              <Link to="/login">Back to Login</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default VerifyEmail;
